/* eslint-disable react-hooks/exhaustive-deps */
import { makeStyles } from '@mui/styles';
import Tabs from 'apollo-react/components/Tabs';
import React, { useState } from 'react';

import { useFormSelector } from '../../../custom-hooks';
import NewComponent from '../../components/editor/components/NewComponent';
import { FORM_MODEL_ATTRIBUTES } from '../../constants/form-manager.constants';
import DynamicField from '../../DynamicField';
import { getPropByModel } from '../../selectors/form-manager.selectors';

const useStyles = makeStyles({
  root: {
    marginBottom: 10,
    display: 'flex',
    '& div[class*="MuiTabs-scroller"]': {
      overflow: 'unset',
    },
  },
});

const SSEditorTabSet = ({ childrenNodes, children, isDetail }) => {
  const classes = useStyles();

  const [selectedTab, setSelectedTab] = useState(0);

  const selectedChildrenNodes =
    useFormSelector(getPropByModel, {
      id: childrenNodes[selectedTab],
      prop: FORM_MODEL_ATTRIBUTES.CHILDREN_NODES,
    }) ?? [];

  const handleChangeTab = (e, value) => {
    setSelectedTab(value);
  };

  return (
    <>
      <Tabs
        value={selectedTab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        className={classes.root}
      >
        {children.map((child, index) => React.cloneElement(child, { tabIndex: index }, null))}
      </Tabs>
      {!selectedChildrenNodes.length && (
        <NewComponent controlParentId={children[selectedTab]?.key} previousControlId="" />
      )}
      {selectedChildrenNodes.map((childKey) => (
        <DynamicField key={childKey} id={childKey} isDetail={isDetail} />
      ))}
    </>
  );
};

export default SSEditorTabSet;
